import { ChartLayoutConfig } from '../common/layout-config';
import { BarChartDataOptionsBuilder } from './bar-chart-data-options-builder';
import { PieChartDataOptionsBuilder } from './pie-chart-data-options-builder';
import { LineAndColumnChartDataOptionsBuilder } from './line-and-column-chart-data-options-builder';
import { HeatmapChartDataOptionsBuilder } from './heatmap-chart-data-options-builder';
import { FavouriteDataAdapter } from '../common/favourite-data-adapter';
import { FavouriteDataOptions } from '../common/favourite-data-options';
import { DrillDownHandler } from '../common/drill-down-builder';
import { chartType } from '../../constants';
import { ChartDataOptionsBuilder } from 'app/components/favourite-layout/favourite/chart-data-options/chart-data-options-builder';
import { AreaChartDataOptionsBuilder } from 'app/components/favourite-layout/favourite/chart-data-options/area-chart-data-options-builder';

export function createChartDataOptionsBuilder(
  dataOptions: FavouriteDataOptions,
  dataAdapter: FavouriteDataAdapter,
  drillDownHandler: DrillDownHandler,
  layoutConfig: ChartLayoutConfig
): ChartDataOptionsBuilder {
  switch (layoutConfig.chartType()) {
    case chartType.LINE:
    case chartType.COLUMN:
      return new LineAndColumnChartDataOptionsBuilder(dataOptions, dataAdapter, drillDownHandler);
    case chartType.BAR:
      return new BarChartDataOptionsBuilder(dataOptions, dataAdapter, drillDownHandler);
    case chartType.PIE:
      return new PieChartDataOptionsBuilder(dataOptions, dataAdapter, drillDownHandler);
    case chartType.HEATMAP:
      return new HeatmapChartDataOptionsBuilder(dataOptions, dataAdapter, drillDownHandler);
    case chartType.AREA:
      return new AreaChartDataOptionsBuilder(dataOptions, dataAdapter, drillDownHandler);
    default:
      return null;
  }
}
